import { IMenuItems } from "./menu";
import menu from "./treatment-submenu.json";

const treatmentSubMenuData: IMenuItems[] = menu as IMenuItems[];

export { treatmentSubMenuData };
